import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'
import admin from './admin'
import assessments from './assessments'
import interviewBooking from './interviewBooking'
import pages from './pages'
import treatment from './treatment'

import { checkAuthFor } from './AuthorizationMixin'

Vue.use(Router)

const router = new Router({
  routes: [
    ...admin,
    ...interviewBooking,
    ...pages,
    ...treatment,
    ...assessments,
    {
      component: () => import('@/views/Due.vue'),
      meta: {
        layout: 'blue',
      },
      name: 'dueTasks',
      path: '/due',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "manage" */ '@/views/LayoutSample.vue')
      },
      meta: {
        layout: 'treatment',
      },
      name: 'layoutSample',
      path: '/layout-sample',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "manage" */ '@/views/Workflows.vue')
      },
      meta: {
        authorizedIf: [{ isSignedIn: true }],
      },
      name: 'workflows',
      path: '/workflows',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "assessments" */ '@/views/Surveys.vue')
      },
      name: 'surveys',
      path: '/frageboegen',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "assessments" */ '@/views/assessments/Pre.vue')
      },
      name: 'preAssessments',
      path: '/messungen/pre',
    },
    {
      component: () => {
        return import(
          /* webpackChunkName: "confirmRegistration" */ '@/views/ConfirmRegistration.vue'
        )
      },
      name: 'confirm-registration',
      path: '/confirm-registration',
    },
    {
      component: () => {
        return import(
          /* webpackChunkName: "confirm-emailchange" */ '@/views/ConfirmEmailChange.vue'
        )
      },
      name: 'confirm-emailchange',
      path: '/confirm-emailchange',
    },
    {
      component: () => {
        return import(/*webpackChunkName: "confirm-reset" */ '@/views/ResetPasswordStep2.vue')
      },
      name: 'confirm-reset',
      path: '/confirm-reset',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "main" */ '@/views/Conversation.vue')
      },
      meta: {
        authorizedIf: [{ isSignedIn: true }],
        layout: 'blue',
      },
      name: 'conversation',
      path: '/conversation',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "main" */ '@/views/About.vue')
      },
      name: 'about',
      path: '/about',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "main" */ '@/views/PatientDashboard.vue')
      },
      meta: {
        authorizedIf: [{ isSignedIn: true }],
        layout: 'blue',
      },
      name: 'home',
      path: '/',
    },
    {
      component: () => {
        // return import(/* webpackChunkName: "main" */ '@/views/RegisterLocked.vue')
        return import(/* webpackChunkName: "main" */ '@/views/Register.vue')
      },
      meta: {
        layout: 'blue',
      },
      name: 'register',
      path: '/register',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "registerCounseling" */ '@/views/RegisterCounseling.vue')
      },
      meta: {
        layout: 'blue',
      },
      name: 'register-counseling',
      path: '/register-counseling',
    },
    {
      component: () => {
        return import(
          /* webpackChunkName: "resend-confirmation" */ '@/views/ResendConfirmation.vue'
        )
      },
      name: 'resend-confirmation',
      path: '/resend-confirmation',
    },
    {
      component: () => {
        return import(
          /* webpackChunkName: "conditionsCounseling" */ '@/views/ConditionsAndDisclaimerCounseling.vue'
        )
      },
      name: 'conditionsCounseling',
      path: '/conditionsCounseling',
    },
    {
      component: () => {
        return import(
          /* webpackChunkName: "conditionsTherapy" */ '@/views/ConditionsAndDisclaimerTreatment.vue'
        )
      },
      name: 'conditionsTherapy',
      path: '/conditionsTherapy',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "main" */ '@/views/Profile.vue')
      },
      meta: {
        authorizedIf: [{ isSignedIn: true }],
        layout: 'blue',
      },
      name: 'profile',
      path: '/profile',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "main" */ '@/views/Login.vue')
      },
      meta: {
        layout: 'blue',
      },
      name: 'login',
      path: '/login',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "main" */ '@/views/ResetPassword.vue')
      },
      meta: {
        layout: 'blue',
      },
      name: 'reset-password',
      path: '/reset-password',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "main" */ '@/views/Interview.vue')
      },
      name: 'interview',
      path: '/interview',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "main" */ '@/views/FAQ.vue')
      },
      meta: {
        layout: 'blue',
      },
      name: 'faq',
      path: '/faq',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "main" */ '@/views/Privacy.vue')
      },
      meta: {
        layout: 'blue',
      },
      name: 'privacy',
      path: '/privacy',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "main" */ '@/views/Imprint.vue')
      },
      meta: {
        layout: 'blue',
      },
      name: 'imprint',
      path: '/imprint',
    },
    {
      component: () => {
        return import(/* webpackChunkName: "main" */ '@/views/Downloads.vue')
      },
      meta: {
        layout: 'blue',
      },
      name: 'downloads',
      path: '/downloads',
    },
  ],
})

router.beforeEach((to, from, next) => {
  if (to.meta.authorizedIf && !checkAuthFor(store.getters.currentUser, to.meta.authorizedIf)) {
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router
